import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialsSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [recentNotifications, setRecentNotifications] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Your original hardcoded testimonials
  const fallbackTestimonials = [
    {
      id: 1,
      quote: "FreelanceHub transformed our business. The quality of work and professionalism exceeded our expectations. Our website redesign increased conversions by 340% within the first month.",
      author: "Sarah Chen",
      role: "Marketing Director",
      company: "TechStart Inc.",
      avatar: "https://randomuser.me/api/portraits/women/32.jpg",
      rating: 5,
      project: "Website Redesign",
      result: "340% increase in conversions"
    },
    {
      id: 2,
      quote: "After struggling with unreliable freelancers for months, FreelanceHub was a breath of fresh air. Clear communication, on-time delivery, and exceptional quality. They delivered our mobile app ahead of schedule.",
      author: "Michael Rodriguez",
      role: "Founder & CEO",
      company: "GreenTech Solutions",
      avatar: "https://randomuser.me/api/portraits/men/45.jpg",
      rating: 5,
      project: "Mobile App Development",
      result: "Delivered 3 days early"
    },
    {
      id: 3,
      quote: "The transparent pricing and project management made everything so smooth. No hidden costs, no surprises. Our brand identity project was completed flawlessly and our brand recognition improved significantly.",
      author: "Jennifer Walsh",
      role: "Operations Manager",
      company: "Retail Plus",
      avatar: "https://randomuser.me/api/portraits/women/28.jpg",
      rating: 5,
      project: "Brand Identity",
      result: "60% brand recognition boost"
    },
    {
      id: 4,
      quote: "FreelanceHub's team understood our vision perfectly. The e-commerce platform they built has been running smoothly for 8 months with zero downtime. Sales have increased by 250%.",
      author: "David Kim",
      role: "E-commerce Director",
      company: "Fashion Forward",
      avatar: "https://randomuser.me/api/portraits/men/38.jpg",
      rating: 5,
      project: "E-commerce Platform",
      result: "250% sales increase"
    },
    {
      id: 5,
      quote: "The social media strategy they created for us was game-changing. Our engagement rates skyrocketed and we gained 15,000 new followers in just 2 months. ROI was incredible.",
      author: "Lisa Thompson",
      role: "Marketing Manager",
      company: "Wellness Co.",
      avatar: "https://randomuser.me/api/portraits/women/41.jpg",
      rating: 5,
      project: "Social Media Marketing",
      result: "15K new followers in 2 months"
    },
    {
      id: 6,
      quote: "Professional, reliable, and results-driven. FreelanceHub delivered our content marketing strategy that increased our organic traffic by 400%. Best investment we've made.",
      author: "Robert Johnson",
      role: "Digital Marketing Lead",
      company: "B2B Solutions",
      avatar: "https://randomuser.me/api/portraits/men/52.jpg",
      rating: 5,
      project: "Content Marketing",
      result: "400% organic traffic increase"
    }
  ];

  // Your original notifications
  const notifications = [
    "Sarah from TechStart just completed a Website Redesign project",
    "Michael from GreenTech received his Mobile App ahead of schedule",
    "Jennifer from Retail Plus launched her new Brand Identity",
    "David from Fashion Forward's E-commerce store went live",
    "Lisa from Wellness Co. gained 15K followers this month",
    "Robert from B2B Solutions saw 400% traffic increase"
  ];

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch('http://localhost/phpValidation/freeuser-landing/get_reviews.php');
        const data = await response.json();
        setTestimonials(data);
      } catch (error) {
        console.error("Failed to fetch testimonials:", error);
        setTestimonials(fallbackTestimonials);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  useEffect(() => {
    if (!isAutoPlaying || testimonials.length === 0) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  useEffect(() => {
    const notificationInterval = setInterval(() => {
      const randomNotification = notifications[Math.floor(Math.random() * notifications.length)];
      const newNotification = {
        id: Date.now(),
        message: randomNotification,
        timestamp: new Date()
      };

      setRecentNotifications(prev => [newNotification, ...prev.slice(0, 2)]);
    }, 8000);

    return () => clearInterval(notificationInterval);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 15000);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 15000);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 15000);
  };

  // Use testimonials if available, otherwise fallback
  const displayTestimonials = testimonials.length > 0 ? testimonials : fallbackTestimonials;

  return (
    <section className="py-20 bg-gray-50 relative overflow-hidden">
      {/* Floating Notifications */}
      {/* <div className="fixed top-20 right-4 z-50 space-y-2">
        {recentNotifications.map((notification, index) => (
          <div
            key={notification.id}
            className={`bg-white shadow-lg rounded-lg p-4 max-w-sm transform transition-all duration-500 ${
              index === 0 ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
            }`}
            style={{ animationDelay: `${index * 200}ms` }}
          >
            <div className="flex items-start">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                <Icon name="CheckCircle" size={16} className="text-green-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm text-gray-800 font-medium">
                  {notification.message}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  Just now
                </p>
              </div>
            </div>
          </div>
        ))}
      </div> */}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-poppins text-gray-900 mb-6">
            What Our Clients
            <span className="text-blue-600"> Are Saying</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what business owners like you have achieved with FreelanceHub.
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
            <div className="flex transition-transform duration-500 ease-in-out"
                 style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
              {displayTestimonials.map((testimonial) => (
                <div key={testimonial.id} className="w-full flex-shrink-0">
                  <div className="p-8 lg:p-12">
                    <div className="grid lg:grid-cols-3 gap-8 items-center">
                      {/* Quote Section */}
                      <div className="lg:col-span-2">
                        {/* Rating Stars */}
                        <div className="flex items-center mb-6">
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <Icon key={i} name="Star" size={20} className="text-yellow-400 fill-current" />
                          ))}
                          <span className="ml-2 text-sm text-gray-600">
                            {testimonial.rating}.0 out of 5
                          </span>
                        </div>

                        {/* Quote */}
                        <blockquote className="text-xl lg:text-2xl text-gray-800 leading-relaxed mb-8 font-medium">
                          <Icon name="Quote" size={32} className="text-blue-200 mb-4" />
                          "{testimonial.quote}"
                        </blockquote>

                        {/* Project Details */}
                        <div className="grid sm:grid-cols-2 gap-4 mb-6">
                          <div className="bg-blue-50 rounded-xl p-4">
                            <div className="text-sm text-blue-600 font-semibold mb-1">Project Type</div>
                            <div className="text-gray-900 font-medium">{testimonial.project}</div>
                          </div>
                          <div className="bg-green-50 rounded-xl p-4">
                            <div className="text-sm text-green-600 font-semibold mb-1">Result Achieved</div>
                            <div className="text-gray-900 font-medium">{testimonial.result}</div>
                          </div>
                        </div>
                      </div>

                      {/* Author Section */}
                      <div className="text-center lg:text-left">
                        <div className="inline-block relative mb-6">
                          <div className="w-24 h-24 rounded-full overflow-hidden mx-auto lg:mx-0">
                            <Image
                              src={testimonial.avatar}
                              alt={testimonial.author}
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                            <Icon name="CheckCircle" size={16} className="text-white" />
                          </div>
                        </div>

                        <div>
                          <h4 className="text-xl font-bold font-poppins text-gray-900 mb-1">
                            {testimonial.author}
                          </h4>
                          <p className="text-gray-600 mb-1">{testimonial.role}</p>
                          <p className="text-blue-600 font-semibold">{testimonial.company}</p>
                        </div>

                        {/* Verified Badge */}
                        <div className="inline-flex items-center mt-4 px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
                          <Icon name="Shield" size={14} className="mr-1" />
                          Verified Client
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Controls */}
          <button
            onClick={prevSlide}
            className="absolute top-1/2 left-4 transform -translate-y-1/2 w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors z-10"
          >
            <Icon name="ChevronLeft" size={24} className="text-gray-600" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute top-1/2 right-4 transform -translate-y-1/2 w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors z-10"
          >
            <Icon name="ChevronRight" size={24} className="text-gray-600" />
          </button>

          {/* Slide Indicators */}
          <div className="flex justify-center mt-8 space-x-2">
            {displayTestimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  index === currentSlide ? 'bg-blue-600' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Stats Section */}
        <div className="mt-16 grid md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-3xl font-bold text-blue-600 mb-2">5000+</div>
            <div className="text-gray-600">Happy Clients</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-green-600 mb-2">98%</div>
            <div className="text-gray-600">Satisfaction Rate</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-purple-600 mb-2">4.9/5</div>
            <div className="text-gray-600">Average Rating</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-orange-600 mb-2">24hrs</div>
            <div className="text-gray-600">Response Time</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;